/**
 * Mitarbeiterfarben für die Jahresansicht im Monitor-Modus (nur Darstellung,
 * nichts wird gespeichert).
 *
 * Die Mitarbeiterfarbe ist das einzige Farbmerkmal der Balken; Kategorien werden nur
 * über die Füllart unterschieden (Abwesenheit = schraffiert, siehe Planungs-CSS).
 * Grau ist nicht enthalten: es steht für „keinem Mitarbeiter zuordenbar“.
 */
export const MONITOR_EMPLOYEE_PALETTE: readonly string[] = [
  '#b86535', 
  '#468a2b', 
  '#2c838a', 
  '#2c348a', 
  '#592c8a', 
  '#8a2c7f', 
  '#913f3f', 
  '#407259', 
  '#ff97d0', 
  '#ffec3e', 
];

/** Neutrale Fallbacks (ohne bestehende Daten zu verändern). */
export const MONITOR_NEUTRAL_EMPLOYEE_COLOR = '#e2e8f0';

function hashOf(id: string): number {
  let hash = 0;
  for (let i = 0; i < id.length; i++) {
    hash = (hash * 31 + id.charCodeAt(i)) | 0;
  }
  return Math.abs(hash);
}

/**
 * Ordnet jedem Mitarbeiter deterministisch eine Farbe zu: Ausgangspunkt ist ein
 * Hash der Benutzer-ID; ist die Farbe im selben Mitarbeiterkreis schon vergeben,
 * wird die nächste freie genommen (Reihenfolge nach Benutzer-ID sortiert). Für
 * dieselben Mitarbeiter ergibt sich daher bei jedem Laden und Ansichtswechsel
 * dieselbe Zuordnung. Erst bei mehr Mitarbeitern als Farben wiederholen sie sich.
 */
export function assignEmployeeColors(userIds: readonly string[]): Map<string, string> {
  const colors = new Map<string, string>();
  const used = new Set<number>();
  const size = MONITOR_EMPLOYEE_PALETTE.length;

  for (const id of [...new Set(userIds)].sort()) {
    const preferred = hashOf(id) % size;
    let index = preferred;
    if (used.size < size) {
      while (used.has(index)) index = (index + 1) % size;
    }
    used.add(index);
    colors.set(id, MONITOR_EMPLOYEE_PALETTE[index]);
  }
  return colors;
}
